// Minimal, dependency-free markdown renderer for conversation transcripts.
// Only handles inline emphasis, code, line breaks and links. Anything fancier
// is escaped for safety. We deliberately do not pull in a markdown library
// for the admin app — bundle size matters and this is a read-only preview.

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function renderInlineMarkdown(input: string): string {
  if (!input) return "";
  let out = escapeHtml(input);

  // Fenced code blocks ```...``` first (multi-line).
  out = out.replace(/```([\s\S]*?)```/g, (_m, code: string) => {
    return `<pre class="mono" style="background:rgba(0,0,0,.05);padding:8px;border-radius:6px;font-size:11px;overflow:auto;margin:6px 0;">${code}</pre>`;
  });

  // Inline code `...`
  out = out.replace(/`([^`]+)`/g, '<code class="mono" style="background:rgba(0,0,0,.06);padding:1px 4px;border-radius:3px;">$1</code>');

  // Bold **...**
  out = out.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");

  // Italic *...* (avoid matching across newlines and avoid bold leftovers)
  out = out.replace(/(^|[^*])\*([^*\n]+)\*/g, "$1<em>$2</em>");

  // Auto-link http(s) URLs.
  out = out.replace(
    /(https?:\/\/[^\s<]+)/g,
    '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>',
  );

  // Line breaks.
  out = out.replace(/\n/g, "<br />");

  return out;
}
